import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface Rubric {
  uid?: string;
  text: string;
  rating_scale_value: number;
  label: string;
}

export enum QuestionType {
  VIDEO = 'video',
  WRITTEN = 'written',
}

export interface Question {
  uid: string;
  order: number;
  question_type: QuestionType;
  question_text: string;
  preparation_time: number;
  response_time: number;
  word_limit: number | null;
  active: boolean;
  video: string;
}

interface CompetencyDetails {
  name: string;
  order: number;
  description: string;
  type: string;
  uid: string;
  weight: number;
  number_of_questions: number;
  rubrics: Rubric[];
  questions: Question[];
}

export type CompetencyDetailsResponse = CompetencyDetails | null;

const useGetCompetencyDetails = (
  interviewUid: string,
  competencyUid: string
) => {
  const body = {
    interview: interviewUid,
    uid: competencyUid,
  };

  const { data, isLoading, isError } = useQuery<
    CompetencyDetailsResponse,
    Error
  >(
    ['getCompetencyDetails', interviewUid, competencyUid],
    async () =>
      fetchWithCsrfToken<CompetencyDetailsResponse>(
        `${PrependUrl.ASYNC}/competency/get_details`,
        'POST',
        body
      ),
    {
      enabled: !!interviewUid && !!competencyUid,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGetCompetencyDetails;
